import React from "react";
import { IonIcon, IonLabel, IonTabBar, IonTabButton } from "@ionic/react";
import { location, informationCircle, checkboxOutline, mapOutline } from "ionicons/icons";

interface MainTabsProps {}

const MainTabBar: React.FC<MainTabsProps> = () => {
    return (
        <IonTabBar slot="bottom">
            <IonTabButton tab="schedule" href="/home">
                <IonIcon icon={checkboxOutline} />
                <IonLabel>Ordina</IonLabel>
            </IonTabButton>
            <IonTabButton tab="speakers" href="/menu">
                <IonIcon icon={mapOutline} />
                <IonLabel>Menù Online</IonLabel>
            </IonTabButton>
            <IonTabButton tab="map" href="/local">
                <IonIcon icon={location} />
                <IonLabel>Nome Locale</IonLabel>
            </IonTabButton>
            <IonTabButton tab="about" href="/about">
                <IonIcon icon={informationCircle} />
                <IonLabel>Informazioni</IonLabel>
            </IonTabButton>
        </IonTabBar>
    );
};

export default MainTabBar;